import Vue from 'vue'
import store from '../../store'
import firebase from 'firebase/app'

export default {
  namespaced: true,
  state () {
    return {
      routineRefs: [],
      reference: null
    }
  },
  getters: {
    routineRefs (state) {
      return state.routineRefs
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state) {
      state.routineRefs = []
    },
    add (state, payload) {
      state.routineRefs.push(payload)
    },
    update (state, payload) {
      const index = state.routineRefs.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        Vue.set(state.routineRefs, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.routineRefs.findIndex(ref => ref.key === payload.key)
      if (index !== -1) {
        state.routineRefs.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        var user = this.getters['authUser/user']
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var keys = Object.keys(user.services)
        var tempKeys = []
        var count = 0
        for (var i in keys) {
          if (user.services[keys[i]]) {
            tempKeys.push(keys[i])
            count += 1
          }
        }
        var dbRef = db.collection('routine_refs')
        if (user.role === 'admin' || count > 1) {
          var reference = dbRef.where('enable', '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              const payload = {
                key: change.doc.id,
                owner: change.doc.data().owner,
                title: change.doc.data().title,
                subTitle: change.doc.data().subTitle,
                routine_ref: change.doc.data().routine_ref,
                category: change.doc.data().category,
                icon: change.doc.data().icon,
                startAt: change.doc.data().startAt,
                startAtText: change.doc.data().startAtText,
                endAt: change.doc.data().endAt,
                endAtText: change.doc.data().endAtText,
                enable: change.doc.data().enable,
                services: change.doc.data().services,
                createdAt: change.doc.data().createdAt,
                updatedAt: change.doc.data().updatedAt
              }
              var check = false
              for (var k in user.services) {
                if (user.services[k] && payload.services[k]) {
                  check = true
                }
              }
              if (change.type === 'added' && (user.role === 'admin' || check)) {
                if (change.type === 'added') {
                  commit('add', JSON.parse(JSON.stringify(payload)))
                } else if (change.type === 'modified') {
                  commit('update', JSON.parse(JSON.stringify(payload)))
                } else if (change.type === 'removed') {
                  commit('remove', JSON.parse(JSON.stringify(payload)))
                }
              }
            })
            resolve()
          })
        } else if (tempKeys.length === 1) {
          reference = dbRef.where('services.' + tempKeys[0], '==', true).where('enable', '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              const payload = {
                key: change.doc.id,
                owner: change.doc.data().owner,
                title: change.doc.data().title,
                subTitle: change.doc.data().subTitle,
                routine_ref: change.doc.data().routine_ref,
                category: change.doc.data().category,
                icon: change.doc.data().icon,
                startAt: change.doc.data().startAt,
                startAtText: change.doc.data().startAtText,
                endAt: change.doc.data().endAt,
                endAtText: change.doc.data().endAtText,
                enable: change.doc.data().enable,
                services: change.doc.data().services,
                createdAt: change.doc.data().createdAt,
                updatedAt: change.doc.data().updatedAt
              }
              if (change.type === 'added') {
                commit('add', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'modified') {
                commit('update', JSON.parse(JSON.stringify(payload)))
              } else if (change.type === 'removed') {
                commit('remove', JSON.parse(JSON.stringify(payload)))
              }
            })
            resolve()
          })
        } else {
          resolve()
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['routineRef/reference']
      return new Promise((resolve, reject) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/RoutineRef.js